// extracted by mini-css-extract-plugin
module.exports = {"container":"contact_container__FSOJU","list":"contact_list__N2YkT","address":"contact_address__JG9Sh"};